import { render, staticRenderFns } from "./activityUser.vue?vue&type=template&id=06707a23&scoped=true&"
import script from "./activityUser.vue?vue&type=script&lang=js&"
export * from "./activityUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06707a23",
  null
  
)

export default component.exports